import { investmentService } from "../investments/investmentService";
import { activityService } from "../activity/activityService";
import { usersService } from "../users/usersService";

export const verifyFinancialSystem = async (userId) => {
    const results = [];
    try {
        // Fetch the correct user profile
        const profile = await usersService.getUserProfile(userId);
        // Verifying userId and profile balance
        // Test 1: User Profile
        if (profile) {
            results.push({
                test: "User Profile",
                passed: true,
                details: `Balance: €${(profile.balance || 0).toLocaleString()}, KYC: ${profile.kycStatus || "pending"}`,
                timestamp: new Date().toISOString()
            });
        } else {
            results.push({
                test: "User Profile",
                passed: false,
                details: "User profile not found",
                timestamp: new Date().toISOString()
            });
        }

        // Test 2: Investment System
        const investments = await investmentService.getUserInvestments(userId);
        const portfolioData = await investmentService.calculatePortfolioValue(userId);
        results.push({
            test: "Investment System",
            passed: true,
            details: `Investments: ${investments.length}, Total Value: €${portfolioData.totalValue.toLocaleString()}`,
            timestamp: new Date().toISOString()
        });

        // Test 3: Transaction System
        const transactions = (await activityService.getUserTransactions(userId)) || [];
        results.push({
            test: "Transaction System",
            passed: true,
            details: `Transactions: ${transactions.length}`,
            timestamp: new Date().toISOString()
        });

        // Test 4: Financial Consistency
        if (profile) {
            const currentBalance = profile.balance || 0;
            const expectedBalance = Array.isArray(transactions)
                ? transactions.reduce((sum, t) => sum + (t.amount || 0), 0)
                : 0;
            const balanceDifference = Math.abs(currentBalance - expectedBalance);

            results.push({
                test: "Financial Consistency",
                passed: balanceDifference < 0.01,
                details: `Balance: €${currentBalance.toLocaleString()}, Expected: €${expectedBalance.toLocaleString()}`,
                timestamp: new Date().toISOString()
            });
        }
    } catch (error) {
        // Enhanced error logging for debugging
        results.push({
            test: "Verification Process",
            passed: false,
            details: error && error.stack ? error.stack : error.message,
            timestamp: new Date().toISOString()
        });
    }
    return results;
};